import CitySEOHead from "@/components/feature/CitySEOHead";
import WisconsinHeroSection from "./components/HeroSection";
import WisconsinCitiesDirectory from "./components/CitiesDirectory";
import WisconsinStateResources from "./components/StateResources";
import WisconsinFAQSection, { faqs } from "./components/FAQSection";
import WisconsinFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

export default function WisconsinPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wisconsin"
        state="Wisconsin"
        stateAbbr="WI"
        route="/wisconsin/"
        title="Wisconsin Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Wisconsin — Milwaukee, Madison, Green Bay, Racine. No local passport agency in WI — we courier to Chicago. Emergency processing as fast as 24 hours. A+ BBB rated."
        geoPlacename="Wisconsin, United States"
        geoPosition="44.5000;-89.5000"
        faqs={faqs.map(f => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
      />
      <WisconsinHeroSection />
      <WisconsinCitiesDirectory />
      <WisconsinStateResources />
      <WisconsinFAQSection />
      <SEOCrossLinks state="WI" />
      <WisconsinFinalCTA />
    </div>
  );
}